<div [className]="getClassName()">
    <div class="items">
        <div class="item">
            <div class="name">{{"label.catalog" | translate}}</div>
        </div>
        <div *ngFor="let item of items" class="item" (click)="onClickIten(item)" [class.clicked]="item.label == currentClickedSerie?.label">
            <div class="name">{{item.label}}</div>
        </div>
    </div>
</div>